<template>
    <div>
        <auth-container :page="page">
            <h2 class="mb-4">Dams</h2>

            <b-table-simple style="width:auto">
                <b-tbody>
                    <b-tr>
                        <b-th>Total repair need cost</b-th>
                        <b-td class="text-right">${{data.repairNeedCostTotal | number(2)}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>Number of dams needing repair</b-th>
                        <b-td class="text-right">{{data.repairNeedCount}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th>
                            Number of dams with high hazard upgrade/rehab needed
                            <span v-b-tooltip.hover title="Where HAZ DESIGN = H and (HAZ DESIGN not equal to TCEQ HAZ or HAZ DESIGN not equal to NRCS HAZ)">
                                <font-awesome-icon :icon="['fas', 'info-circle']" class="text-info pointer" />
                            </span>
                        </b-th>
                        <b-td class="text-right">{{data.highHazardDamCount}}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </auth-container>
    </div>
</template>

<script>
    export default {
        name: 'SrReportDams',
        data() {
            return {
                page: {
                    errors: [],
                    loading: true,
                    showLogin: false,
                },
                data: {
                    repairNeedCostTotal: 0,
                    repairNeedCount: 0,
                    highHazardDamCount: 0,
                }
            }
        },
        async created() {
            await this.get();
        },
        watch: {
            '$route': 'get',
        },
        methods: {
            async get() {
                this.page.errors = [];
                this.page.loading = true;

                try {
                    const response = await this.$http.get(`srreports/dams`, this.getTokenHeader());
                    this.log(response.data);
                    this.data = response.data;
                } catch (error) {
                    if (this.isApiUnauthorized(error)) this.page.showLogin = true;
                    else this.page.errors = this.logError(error);
                }

                this.page.loading = false;
            },
        },
    }
</script>